import { useDispatch } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationOptions } from "@tanstack/react-query";

import { getProviderProfile as getProviderProfileAction } from "@/redux/actions/auth";
import { UpdateProviderProfilePayload } from "@/api/(requests)/providerTyped";

import { providerProfileKeys } from "../keyFactory";
import { updateProviderProfile } from "../queryFunctions/updateProviderProfile";

type Variables = { body: UpdateProviderProfilePayload; providerId?: string };

export function useUpdateProviderProfile(
  providerId?: string,
  options: UseMutationOptions<void, unknown, Variables> = {},
) {
  const { onSuccess, ...rest } = options;
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateProviderProfile,
    ...rest,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: providerProfileKeys.details(providerId) });
      // keep Redux store in sync for legacy consumers
      // TODO: if dispatch fails, onSuccess still fires — callers should not assume Redux is in sync
      dispatch(getProviderProfileAction(providerId));
      onSuccess?.(data, variables, context);
    },
  });
}
